export const packageGroups = [
  {
    id: "corporate",
    note: "domain",
    items: [
      {
        id: "corpBronze",
        price: { tr: 17000, en: 490, de: 460 },
        oldPrice: { tr: 24000, en: 690, de: 650 },
        popular: false,
      },
      {
        id: "corpSilver",
        price: { tr: 25000, en: 690, de: 650 },
        oldPrice: { tr: 35000, en: 990, de: 920 },
        popular: true,
      },
      {
        id: "corpGold",
        price: { tr: 35000, en: 980, de: 910 },
        oldPrice: { tr: 50000, en: 1400, de: 1300 },
        popular: false,
      },
    ],
  },
  {
    id: "ecommerce",
    note: "domain",
    items: [
      {
        id: "ecomBronze",
        price: { tr: 95000, en: 2650, de: 2450 },
        popular: false,
      },
      {
        id: "ecomSilver",
        price: { tr: 145000, en: 3950, de: 3650 },
        popular: true,
      },
      {
        id: "ecomGold",
        price: { tr: 210000, en: 5800, de: 5350 },
        popular: false,
      },
    ],
  },
  {
    id: "crm",
    note: "software",
    items: [
      {
        id: "crmStart",
        price: { tr: 160000, en: 4400, de: 4100 },
        popular: false,
      },
      {
        id: "crmOps",
        price: { tr: 295000, en: 7950, de: 7450 },
        popular: true,
      },
      {
        id: "crmEnt",
        price: { tr: 520000, en: 13900, de: 12900 },
        popular: false,
      },
    ],
  },
  {
    id: "b2b",
    note: "software",
    items: [
      {
        id: "b2bDealer",
        price: { tr: 185000, en: 4950, de: 4650 },
        popular: true,
      },
      {
        id: "b2bPlatform",
        price: { tr: 360000, en: 9800, de: 9100 },
        popular: false,
      },
    ],
  },
  {
    id: "mobile",
    note: "stores",
    items: [
      {
        id: "mobileMvp",
        price: { tr: 160000, en: 4400, de: 4100 },
        popular: false,
      },
      {
        id: "mobileBiz",
        price: { tr: 385000, en: 10500, de: 9750 },
        popular: true,
      },
    ],
  },
  {
    id: "integrations",
    note: "license",
    items: [
      {
        id: "intPos",
        price: { tr: 18000, en: 490, de: 460 },
        oldPrice: { tr: 25000, en: 680, de: 640 },
        popular: false,
      },
      {
        id: "intAcc",
        price: { tr: 20000, en: 550, de: 500 },
        oldPrice: { tr: 25000, en: 690, de: 625 },
        popular: false,
      },
      {
        id: "intBundle",
        price: { tr: 35000, en: 950, de: 890 },
        oldPrice: { tr: 50000, en: 1350, de: 1270 },
        popular: true,
      },
    ],
  },
];

export const extraServices = [
  { id: "erp", priceKey: "from320", highlight: true },
  { id: "events", priceKey: "from180" },
  { id: "callcenter", priceKey: "from45" },
];

export const serviceIds = [
  "crm",
  "b2b",
  "events",
  "web",
  "mobile",
  "callcenter",
  "accounting",
  "pos",
  "erp",
];

export function getRawPrice(val, locale = "tr") {
  if (val && typeof val === "object") {
    return val[locale] ?? val.tr ?? 0;
  }
  return typeof val === "number" ? val : 0;
}

export function formatPrice(val, locale = "tr") {
  const amount = getRawPrice(val, locale);
  if (locale === "en") {
    return `$${amount.toLocaleString("en-US")}`;
  }
  if (locale === "de") {
    return `${amount.toLocaleString("de-DE")} €`;
  }
  return `${amount.toLocaleString("tr-TR")}₺`;
}

export function getDiscountPercent(price, oldPrice, locale = "tr") {
  const p = getRawPrice(price, locale);
  const op = getRawPrice(oldPrice, locale);
  if (!op || !p || op <= p) return 0;
  return Math.round((1 - p / op) * 100);
}

export function formatDiscountBadge(price, oldPrice, locale = "tr") {
  const pct = getDiscountPercent(price, oldPrice, locale);
  if (!pct) return "";
  return locale === "tr" ? `-%${pct}` : `-${pct}%`;
}

export function formatTry(amount) {
  const num = getRawPrice(amount, "tr");
  return `${num.toLocaleString("tr-TR")}₺`;
}
